import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import './i18n'; // 导入i18n配置
import { ThemeProvider } from './theme/ThemeProvider';
import { App as AntdApp } from 'antd';
import { UsageProvider } from './contexts/UsageContext';

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  // <React.StrictMode> {/* Temporarily disabled - causes WebSocket connection issues */}
    <ThemeProvider>
      <AntdApp>
        <UsageProvider>
          <App />
        </UsageProvider>
      </AntdApp>
    </ThemeProvider>
  // </React.StrictMode>
);
